import br2_1 from "./br2-1.jpg";
import br2_2 from "./br2-2.jpg";
import br2_3 from "./br2-3.jpg";
import br2_4 from "./br2-4.jpg";
import br2_5 from "./br2-5.jpg";
import br2_6 from "./br2-6.jpg";
import br2_7 from "./br2-7.jpg";
import br2_8 from "./br2-8.jpg";
import br2_9 from "./br2-9.jpg";
import br2_10 from "./br2-10.jpg";
import br2_11 from "./br2-11.jpg";
import br2_12 from "./br2-12.jpg";
import br2_13 from "./br2-13.jpg";
import br2_14 from "./br2-14.jpg";
import br2_15 from "./br2-15.jpg";
import br2_16 from "./br2-16.jpg";
import br2_17 from "./br2-17.jpg";
import br2_18 from "./br2-18.jpg";
import br2_19 from "./br2-19.jpg";
import br2_20 from "./br2-20.jpg";
import br2_21 from "./br2-21.jpg";
import br2_22 from "./br2-22.jpg";
import br2_23 from "./br2-23.jpg";
import br2_24 from "./br2-24.jpg";
import br2_25 from "./br2-25.jpg";
import br2_26 from "./br2-26.jpg";
import br2Fp1np3d from "./br2-fp-1np-3d.jpg";
import br2Fp1np2d from "./br2-fp-1np-2d.jpg";
import br2Fp2np3d from "./br2-fp-2np-3d.jpg";
import br2Fp2np2d from "./br2-fp-2np-2d.jpg";

export const brnik2Images = [
  br2_1, br2_2, br2_3, br2_4, br2_5, br2_6, br2_7, br2_8, br2_9, br2_10,
  br2_11, br2_12, br2_13, br2_14, br2_15, br2_16, br2_17, br2_18, br2_19, br2_20,
  br2_21, br2_22, br2_23, br2_24, br2_25, br2_26,
];

export const brnik2FloorPlans = [
  { image: br2Fp1np3d, label: "1. NP – 3D" },
  { image: br2Fp1np2d, label: "1. NP – 2D" },
  { image: br2Fp2np3d, label: "2. NP – 3D" },
  { image: br2Fp2np2d, label: "2. NP – 2D" },
];
